/* eslint-disable @typescript-eslint/no-explicit-any */
// 顺序要紧: leafletGlobal 先把全局 L 就位, 插件模块体才能正常求值
import L from './leafletGlobal';
import * as GoogleMutantModule from 'leaflet.gridlayer.googlemutant';

/**
 * Leaflet 插件初始化 (GoogleMutant 注册)。使用方必须先 import 本模块, 再 import 'leaflet-draw'。
 *
 * <p><b>构造器要按形态挖</b>: 该包 package.json 的 {@code browser} 字段指向
 * {@code dist/Leaflet.GoogleMutant.js} —— 一个老式全局脚本 ({@code this.L.GridLayer.GoogleMutant = ...})。
 * webpack 打 CJS 时顶层 {@code this} 就是 {@code module.exports}, 于是类被挂到
 * <b>模块对象的 {@code .L.GridLayer.GoogleMutant}</b> 上, 既不是 {@code default} 也不是函数
 * (直接 new 默认导出会报 "is not a constructor")。
 *
 * <p>因此这里按优先级依次尝试: ESM 默认导出 → dist 的 {@code .L.GridLayer.GoogleMutant}
 * → 模块本身即构造器。三种打包结果都能兜住。
 */
const mod: any = GoogleMutantModule;
const ctor: any = (typeof mod?.default === 'function' && mod.default)
    || mod?.L?.GridLayer?.GoogleMutant
    || (typeof mod === 'function' ? mod : undefined);

if (typeof ctor === 'function') {
    (L as any).GridLayer.GoogleMutant = ctor;
    (L as any).gridLayer.googleMutant = (options?: unknown) => new ctor(options);
} else {
    // eslint-disable-next-line no-console
    console.error('[leafletSetup] GoogleMutant 构造器解析失败, Google 底图不可用', GoogleMutantModule);
}

export default L;

/**
 * 顶点手柄瘦身。
 *
 * <p>Leaflet 检测到浏览器有触摸能力就会给容器打 `leaflet-touch`, 此时 leaflet-draw 的顶点方块
 * 被 CSS 放大到 20px —— 桌面端鼠标操作根本不需要这么大的热区, 画小面时方块盖住的比面还多,
 * 顶点位置全靠猜。这里压到 10px (中点手柄再小一档), 同时保留 4px 的透明外扩热区,
 * 手感不受影响 (Leaflet 的命中判定看 icon 尺寸, 用 box-shadow 撑热区不影响视觉大小)。
 */
const VERTEX_HANDLE_STYLE_ID = '__aoi_v2_vertex_handle_style__';
if (typeof document !== 'undefined' && !document.getElementById(VERTEX_HANDLE_STYLE_ID)) {
    const style = document.createElement('style');
    style.id = VERTEX_HANDLE_STYLE_ID;
    style.textContent = `
.leaflet-container .leaflet-editing-icon,
.leaflet-touch .leaflet-editing-icon {
    width: 10px !important;
    height: 10px !important;
    margin-left: -5px !important;
    margin-top: -5px !important;
    border-width: 1px !important;
    border-radius: 2px;
    box-shadow: 0 0 0 4px rgba(0, 0, 0, 0);
}
/* 拖边中点插入的"幽灵"手柄再小一档, 跟真实顶点区分开 */
.leaflet-container .leaflet-edit-move.leaflet-editing-icon,
.leaflet-touch .leaflet-edit-move.leaflet-editing-icon {
    width: 8px !important;
    height: 8px !important;
    margin-left: -4px !important;
    margin-top: -4px !important;
    opacity: .75;
}
`;
    document.head.appendChild(style);
}
